import { useEffect } from 'react';

import { Typography } from '@capsule/consumer-design-system';

import { useHistory } from 'react-router';
import { css } from 'styled-components';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { SimpleFeatureLayout } from 'src/app/components/FeatureLayouts/SimpleFeatureLayout/SimpleFeatureLayout';
import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';
import { medications } from 'src/app/router/paths';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import type { HealthProfileFormProps } from '..';
import { HealthProfileUpdateStepNames } from '../constants';

export const GotIt = (props: HealthProfileFormProps) => {
  const { onToggleHideHeader } = props;

  useEffect(() => onToggleHideHeader(false));
  const currentStepName = HealthProfileUpdateStepNames.GotIt;
  const history = useHistory();
  const goHome = () => history.push(medications.route);
  useSegmentEvent('viewHealthProfileFormConfirmation', {
    shouldTrackOnMount: true,
    payload: { type: `no_meds_you're_all_set` },
  });

  return (
    <SimpleFeatureLayout
      backButton={{ isRendered: false }}
      keyName={currentStepName}
      title={
        <>
          <CapsuleIcon
            iconString={CAPSULE_ICON_STRINGS.check_circle_large_green}
            css={css`
              width: 72px;
              height: 72px;
              svg {
                width: 72px !important;
                height: 72px !important;
              }
            `}
          />
          <Typography
            css={css`
              margin-top: ${({ theme }) => theme.space.s4};
            `}
            variant={{ base: 'displayXl', smallDown: 'heading1' }}
          >
            You're all set
          </Typography>
        </>
      }
      description={
        <div
          css={css`
            margin-top: ${({ theme }) => theme.space.s2};
          `}
        >
          <Typography variant={'body'}>
            Thanks for confirming. We've updated your health profile with this information.
          </Typography>
        </div>
      }
      body={{ content: <div /> }}
      cta1={{
        children: `Done`,
        onClick: async () => {
          goHome();
        },
      }}
    />
  );
};
